// @flow
import VehicleActions from 'common/redux/actions/vehicle';
import { VehicleModel } from 'common/models/internal/Plan';
import * as Immutable from 'immutable';

export const vehicleReducer = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {
        case VehicleActions.SET_IS_FETCHING_VEHICLE_MODELS_IN_PROGRESS: {
            const isFetchingVehicleModelsInProgress = action.response;
            const { clientId } = action.params;
            return state.setIn(
                [clientId, 'isFetchingVehicleModelsInProgress'],
                isFetchingVehicleModelsInProgress
            );
        }

        case VehicleActions.INJECT_VEHICLE_MODELS: {
            const vehicleModels = action.response;
            const vehicleModelsImmutable = Immutable.List().withMutations(
                vehicleModelsImmutable => {
                    vehicleModels.forEach(vehicleModel => {
                        vehicleModel.idAttr = `${vehicleModel.id.clientId}-${vehicleModel.id.modelId}`;
                        const vehicleModelImmutable = VehicleModel.fromJS(
                            vehicleModel
                        );
                        vehicleModelsImmutable.push(vehicleModelImmutable);
                    });
                }
            );
            const { clientId } = action.params;
            return state
                .setIn([clientId, 'vehicleModels'], vehicleModelsImmutable)
                .setIn([clientId, 'isFetchingVehicleModelsInProgress'], false);
        }

        default:
            return state;
    }
};
